// /accept-invite?token=... (FR-041 to FR-045; SA-AUTH-1). Works signed in or not.
import { AcceptInviteScreen } from "@/auth/links/AcceptInviteScreen";

export default function AcceptInvite() {
  return <AcceptInviteScreen />;
}
